export type Language = 'en' | 'de'

export const translations = {
  en: {
    nav: {
      services: 'Services',
      about: 'About',
      contact: 'Contact',
    },
    hero: {
      badge: 'Project Management Excellence',
      headline: 'German Structure Meets Danish Pragmatism',
      subheadline:
        'With 25+ years of international project management experience, I help SMEs execute projects with confidence.',
      cta: "Let's Talk",
      features: ['Projects', 'Workshops', 'Mentoring'],
      stats: [
        { value: '25+', label: 'Years Experience' },
        { value: '100+', label: 'Projects Delivered' },
        { value: '15+', label: 'Countries' },
      ],
    },
    services: {
      label: 'What I offer',
      title: 'Services',
      items: [
        {
          title: 'Training & Workshops',
          description:
            'Tailored trainings, tools, and templates for project managers and teams — on-site or online. Build real project management competence where it matters most.',
        },
        {
          title: 'PM Consulting',
          description:
            'From risk and contract management to PM maturity analysis and software selection — structured support for your project management challenges.',
        },
        {
          title: 'Mentoring & Coaching',
          description:
            'Individual mentoring and coaching for project managers. Because sometimes all it takes is an experienced perspective by your side.',
        },
      ],
    },
    about: {
      label: 'Get to know me',
      title: 'About Anja Böhm',
      description:
        'With over 25 years of practical experience in international projects at companies like Bosch and Syntegon, I support businesses in building effective project management structures. As a certified PMP® and Diplom-Ingenieur, I combine German thoroughness with Danish pragmatism: solution-oriented and focused on what truly matters.',
      story:
        'As a young project manager, I often needed courage and perseverance and would have loved to have an experienced mentor by my side. Now, living in Denmark, I offer exactly that support to others.',
      facts: [
        '25+ years experience',
        'PMP® Certified',
        'SAFe® Agilist',
        'International Projects',
      ],
    },
    contact: {
      title: 'Ready to strengthen your project management?',
      subtext:
        "Whether you need training, consulting, or a sparring partner — let's find out how I can support you.",
      cta: 'Get in Touch',
    },
    footer: {
      copyright: '© 2026 LBG Consulting — Anja Böhm',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
    },
  },
  de: {
    nav: {
      services: 'Leistungen',
      about: 'Über mich',
      contact: 'Kontakt',
    },
    hero: {
      badge: 'Projektmanagement-Exzellenz',
      headline: 'Deutsche Struktur trifft dänischen Pragmatismus',
      subheadline:
        'Mit über 25 Jahren internationaler Projektmanagement-Erfahrung unterstütze ich KMU dabei, Projekte sicher und erfolgreich umzusetzen.',
      cta: 'Kontakt aufnehmen',
      features: ['Projekte', 'Workshops', 'Mentoring'],
      stats: [
        { value: '25+', label: 'Jahre Erfahrung' },
        { value: '100+', label: 'Projekte umgesetzt' },
        { value: '15+', label: 'Länder' },
      ],
    },
    services: {
      label: 'Was ich anbiete',
      title: 'Leistungen',
      items: [
        {
          title: 'Training & Workshops',
          description:
            'Maßgeschneiderte Trainings, Tools und Templates für Projektmanager und Teams — vor Ort oder online. Echte Projektmanagement-Kompetenz aufbauen, wo es zählt.',
        },
        {
          title: 'PM Beratung',
          description:
            'Von Risiko- und Vertragsmanagement bis zur PM-Reifegradanalyse und Softwareauswahl — strukturierte Unterstützung für Ihre Projektmanagement-Herausforderungen.',
        },
        {
          title: 'Mentoring & Coaching',
          description:
            'Individuelles Mentoring und Coaching für Projektmanager:innen. Manchmal braucht es nur eine erfahrene Perspektive an Ihrer Seite.',
        },
      ],
    },
    about: {
      label: 'Lernen Sie mich kennen',
      title: 'Über Anja Böhm',
      description:
        'Mit über 25 Jahren Praxiserfahrung in internationalen Projekten bei Unternehmen wie Bosch und Syntegon unterstütze ich Firmen dabei, effektive Projektmanagement-Strukturen aufzubauen. Als zertifizierte PMP® und Diplom-Ingenieurin verbinde ich deutsche Gründlichkeit mit dänischem Pragmatismus: lösungsorientiert und fokussiert auf das Wesentliche.',
      story:
        'Als junge Projektleiterin brauchte ich oft Mut und Ausdauer und hätte mir einen erfahrenen Mentor an meiner Seite gewünscht. Heute, in Dänemark lebend, biete ich genau diese Unterstützung an.',
      facts: [
        '25+ Jahre Erfahrung',
        'PMP® Zertifiziert',
        'SAFe® Agilist',
        'Internationale Projekte',
      ],
    },
    contact: {
      title: 'Bereit, Ihr Projektmanagement zu stärken?',
      subtext:
        'Ob Training, Beratung oder Sparringspartner — lassen Sie uns herausfinden, wie ich Sie unterstützen kann.',
      cta: 'Kontakt aufnehmen',
    },
    footer: {
      copyright: '© 2026 LBG Consulting — Anja Böhm',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
    },
  },
}
